import * as marietta from '../..';
import { ALMOST_ZERO } from '../Constants';
import { SVGSprite } from '../flash/display';
import { Stage } from '../model';
import ItemController from './ItemController';
import { ITEM_MODE_KEY } from '../Constants';

/**
 * guide Itemcontrollerクラス
 */
export default class ItemControllerWithGuide extends ItemController {
  itemguide: marietta.webcad.control.parts.ItemGuide;

  itemBoundRectRight: marietta.webcad.control.parts.ItemBoundRect;

  itemBoundRectLeft: marietta.webcad.control.parts.ItemBoundRect;

  itemBoundRectTop: marietta.webcad.control.parts.ItemBoundRect;

  itemBoundRectBottom: marietta.webcad.control.parts.ItemBoundRect;

  distanceTop: any;

  distanceRight: any;

  distanceBottom: any;

  distanceLeft: any;

  public guideSpt: SVGSprite;

  public itemBoundGuideSpt: SVGSprite;

  /**
   * コンストラクタ
   */
  constructor(_target: marietta.webcad.item.MonicaObject) {
    super(_target);
    const tarLayer: marietta.webcad.layer.FloorShitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.target.itemInfo.floor, true) as marietta.webcad.layer.FloorShitaeLayer;

    // 形状の生成
    const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    viewObj.id = 'controller';

    const viewItemBoundGuide: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    viewItemBoundGuide.id = 'itemBoundGuide';
    this.itemBoundRectRight = new marietta.webcad.control.parts.ItemBoundRect(viewItemBoundGuide, 'itemBoundRectRight');
    this.itemBoundRectLeft = new marietta.webcad.control.parts.ItemBoundRect(viewItemBoundGuide, 'itemBoundRectLeft');
    this.itemBoundRectTop = new marietta.webcad.control.parts.ItemBoundRect(viewItemBoundGuide, 'itemBoundRectTop');
    this.itemBoundRectBottom = new marietta.webcad.control.parts.ItemBoundRect(viewItemBoundGuide, 'itemBoundRectBottom');
    tarLayer.viewObj.appendChild(viewItemBoundGuide);
    this.itemBoundGuideSpt = new SVGSprite(viewItemBoundGuide);

    // バウンドボックスとガイドライン
    const viewObjGuide: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    viewObjGuide.id = 'guide';
    this.itemguide = new marietta.webcad.control.parts.ItemGuide(viewObjGuide);
    tarLayer.viewObj.appendChild(viewObjGuide);
    this.guideSpt = new SVGSprite(viewObjGuide);
    if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.guideVisible) {
      this.hideItemGuide();
    }

    // 全体のボックス
    this.allBox = new marietta.webcad.control.parts.BoundingBox(viewObj);
    // 回転
    this.rotator = new marietta.webcad.control.parts.ControlRotator(viewObj);
    this.rotator.rotateStartFunc = this.rotateStartWithGuide;
    this.rotator.rotateFunc = this.rotateWithGuide;
    this.rotator.rotateEndFunc = this.rotateEnd;

    // モバイル
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      // 削除ボタン
      this.btnDelete = new marietta.webcad.control.parts.ButtonGarbage(viewObj, this.target);
      // 反転ボタン
      this.btnReverse = new marietta.webcad.control.parts.ButtonReverse(viewObj, this.target);
      // 移動軸
      this.btnDragger = new marietta.webcad.control.parts.DraggerMobile(viewObj, this.target);
      this.btnDragger.dragFunc = this.onMoveDragger;
      this.btnDragger.dragEndFunc = this.onMoveEndDragger;
    }

    // ピッカー
    this.dragObj_T = new marietta.webcad.control.parts.ControlPicker(viewObj, 'T');
    this.dragObj_T.moveFunc = this.onMoveControlPicker;
    this.dragObj_T.moveEndFunc = this.onMoveEndControlPicker;
    this.dragObj_TL = new marietta.webcad.control.parts.ControlPicker(viewObj, 'TL');
    this.dragObj_TL.moveFunc = this.onMoveControlPicker;
    this.dragObj_TL.moveEndFunc = this.onMoveEndControlPicker;
    this.dragObj_TR = new marietta.webcad.control.parts.ControlPicker(viewObj, 'TR');
    this.dragObj_TR.moveFunc = this.onMoveControlPicker;
    this.dragObj_TR.moveEndFunc = this.onMoveEndControlPicker;
    this.dragObj_L = new marietta.webcad.control.parts.ControlPicker(viewObj, 'L');
    this.dragObj_L.moveFunc = this.onMoveControlPicker;
    this.dragObj_L.moveEndFunc = this.onMoveEndControlPicker;
    this.dragObj_R = new marietta.webcad.control.parts.ControlPicker(viewObj, 'R');
    this.dragObj_R.moveFunc = this.onMoveControlPicker;
    this.dragObj_R.moveEndFunc = this.onMoveEndControlPicker;
    this.dragObj_B = new marietta.webcad.control.parts.ControlPicker(viewObj, 'B');
    this.dragObj_B.moveFunc = this.onMoveControlPicker;
    this.dragObj_B.moveEndFunc = this.onMoveEndControlPicker;
    this.dragObj_BL = new marietta.webcad.control.parts.ControlPicker(viewObj, 'BL');
    this.dragObj_BL.moveFunc = this.onMoveControlPicker;
    this.dragObj_BL.moveEndFunc = this.onMoveEndControlPicker;
    this.dragObj_BR = new marietta.webcad.control.parts.ControlPicker(viewObj, 'BR');
    this.dragObj_BR.moveFunc = this.onMoveControlPicker;
    this.dragObj_BR.moveEndFunc = this.onMoveEndControlPicker;

    // モバイル
    if (ua.isMobile || ua.isTablet) {
      this.dragObj_T.hide();
      this.dragObj_L.hide();
      this.dragObj_R.hide();
      this.dragObj_B.hide();
    }
    if (this.target.itemInfo.lock) {
      this.hideToolTips();
    } else {
      this.showToolTips();
    }

    // エンドアイテムが決まっている場合は、サイズ変更できないので、非表示にする
    if (!this.target.itemInfo.isWhiteItem()) {
      this.dragObj_T.hide();
      this.dragObj_TL.hide();
      this.dragObj_TR.hide();
      this.dragObj_L.hide();
      this.dragObj_R.hide();
      this.dragObj_B.hide();
      this.dragObj_BL.hide();
      this.dragObj_BR.hide();
    }
    if (marietta.webcad.WebCADGlobal.isAutoFacingItem(this.target.itemInfo.id)) {
      this.dragObj_T.hide();
      this.dragObj_L.hide();
      this.dragObj_R.hide();
      this.dragObj_B.hide();
      this.rotator.hide();
    }
    tarLayer.viewObj.appendChild(viewObj);
    this.spt = new SVGSprite(viewObj);
    // ターゲットに合わせてサイズ変更
    this.resizeToTarget();
  }

  /**
   * 初期化
   */
  // eslint-disable-next-line class-methods-use-this
  initMe() {

  }

  /**
   * ターゲットに合わせて各種パーツリサイズ
   */
  resizeToTarget() {
    // 位置合わせ
    this.syncMeToTarget();
    // 一度回転角度を戻してサイズを計測する
    const motoRot: number = this.target.itemInfo.rotation;
    this.target.rotate(0);

    // SVGSpriteのwidth/heightに書き換え
    let { width } = this.target.spt;
    let { height } = this.target.spt;
    if (this.target instanceof marietta.webcad.item.Stair) {
      width = Math.abs((this.target as marietta.webcad.item.Stair).patternSpt.width);
      height = (this.target as marietta.webcad.item.Stair).patternSpt.height;
    } else if (this.target.isHeightEditableItem()) {
      // 住設・家具は描画用に丸めた px でなく mm から置く。伸縮で触らない辺の mm がずれないように
      width = marietta.webcad.util.WebCADUtil.convertMMToPix(this.target.itemInfo.widthmm);
      height = marietta.webcad.util.WebCADUtil.convertMMToPix(this.target.itemInfo.heightmm);
    }

    // ピッカー
    this.dragObj_T.move(0, -height / 2);
    this.dragObj_TL.move(-width / 2, -height / 2);
    this.dragObj_TR.move(width / 2, -height / 2);
    this.dragObj_L.move(-width / 2, 0);
    this.dragObj_R.move(width / 2, 0);
    this.dragObj_B.move(0, height / 2);
    this.dragObj_BL.move(-width / 2, height / 2);
    this.dragObj_BR.move(width / 2, height / 2);

    // 直接、transformをいじらずにmove()関数などを通す
    // 回転
    // this.rotator.transformMatrix = "matrix(1,0,0,1," + -6.5 + "," + (-height/2 - 25) + ")";
    // this.rotator.viewObj.setAttribute("transform", this.rotator.transformMatrix);
    this.rotator.move(-6.5, (-height / 2 - 25));
    // アイコンボタンの位置更新
    this.updateIconButtons();
    // 全体Box
    // rectのwidth/heightプロパティに値が代入出来ないので
    // 直接渡すことに（Firefoxのみ値渡しが出来ていたっぽい）
    this.allBox.resize({ width, height });

    this.allBox.move(this.dragObj_TL.x + (this.dragObj_TR.x - this.dragObj_TL.x) / 2, this.dragObj_TL.y + (this.dragObj_BL.y - this.dragObj_TL.y) / 2);
    this.itemguide.move(this.dragObj_TL.x + (this.dragObj_TR.x - this.dragObj_TL.x) / 2, this.dragObj_TL.y + (this.dragObj_BL.y - this.dragObj_TL.y) / 2);
    // this.allBox.resize( rect );

    // 回転角度を元に戻す
    this.target.rotate(motoRot);

    this.rotation = motoRot;
    const boundBox = this.target.getBoundRect();
    this.itemguide.resize({ width: boundBox.width, height: boundBox.height });
    this.updateTransforms();
  }

  /**
   * Translateのアップデート
   */
  updateTransforms() {
    const dist = this.calculateDistance();
    if (dist && dist.top !== undefined && dist.right !== undefined && dist.bottom !== undefined && dist.left !== undefined) {
      this.showGuide(dist.top, dist.right, dist.bottom, dist.left);
    } else {
      this.hideItemGuide();
    }
    this.spt.x = this.x;
    this.spt.y = this.y;
    this.spt.rotation = this.rotation;
    this.spt.update();

    this.guideSpt.x = this.x;
    this.guideSpt.y = this.y;
    this.guideSpt.update();
  }

  /**
   * 隣接する壁またはアイテムからの距離の計算
   */
  calculateDistance() {
    this.itemguide.hideAllDifferenceLine();
    if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.roomWallList || !marietta.webcad.WebCADGlobal.webcad2Dmanager.guideVisible) return null;

    if (this.target.itemInfo.x !== undefined && this.target.spt) {
      const boundBox = this.target.getBoundRect();
      const topL = new marietta.core.Point(this.target.itemInfo.x - Math.round(boundBox.width) / 2, this.target.itemInfo.y - Math.round(boundBox.height) / 2);
      const topR = new marietta.core.Point(this.target.itemInfo.x + Math.round(boundBox.width) / 2, this.target.itemInfo.y - Math.round(boundBox.height) / 2);
      const bottomL = new marietta.core.Point(this.target.itemInfo.x - Math.round(boundBox.width) / 2, this.target.itemInfo.y + Math.round(boundBox.height) / 2);
      const bottomR = new marietta.core.Point(this.target.itemInfo.x + Math.round(boundBox.width) / 2, this.target.itemInfo.y + Math.round(boundBox.height) / 2);

      this.distanceTop = marietta.webcad.util.ItemGuideUtil.getClosestWallOrItem(this.target, topL, topR, 'top'); // 選択したアイテムの上にある隣接する壁またはアイテムからの距離
      this.distanceRight = marietta.webcad.util.ItemGuideUtil.getClosestWallOrItem(this.target, topR, bottomR, 'right'); // 選択したアイテムの右側にある隣接する壁またはアイテムからの距離
      this.distanceBottom = marietta.webcad.util.ItemGuideUtil.getClosestWallOrItem(this.target, bottomL, bottomR, 'bottom'); // 選択したアイテムの下にある隣接する壁またはアイテムからの距離
      this.distanceLeft = marietta.webcad.util.ItemGuideUtil.getClosestWallOrItem(this.target, topL, bottomL, 'left'); // 選択したアイテムの左側にある隣接する壁またはアイテムからの距離
    }

    return {
      top: this.distanceTop, right: this.distanceRight, bottom: this.distanceBottom, left: this.distanceLeft,
    };
  }

  /**
   * ガイドビューを表示
   * @param distanceTop
   * @param distanceRight
   * @param distanceBottom
   * @param distanceLeft
   */
  showGuide(distanceTop, distanceRight, distanceBottom, distanceLeft) {
    if ((distanceTop && distanceTop.distance != null) && (distanceRight && distanceRight.distance != null) && (distanceBottom && distanceBottom.distance != null) && (distanceLeft && distanceLeft.distance != null)) {
      const guideList = [distanceTop, distanceRight, distanceBottom, distanceLeft];
      guideList.forEach((guide: any) => {
        const guidObj = guide;
        guidObj.startPoint.x -= this.target.itemInfo.x;
        guidObj.startPoint.y -= this.target.itemInfo.y;
        guidObj.point.x -= this.target.itemInfo.x;
        guidObj.point.y -= this.target.itemInfo.y;
      });
      this.createItemBoundRect();
      this.itemguide.updateDistanceLine(distanceTop, distanceRight, distanceBottom, distanceLeft);
      this.itemguide.show();
    } else {
      this.itemguide.hide();
    }
  }

  /**
   * 交差するアイテムの境界線
   */
  createItemBoundRect() {
    this.itemBoundRectRight.hide();
    this.itemBoundRectLeft.hide();
    this.itemBoundRectTop.hide();
    this.itemBoundRectBottom.hide();
    if (this.distanceRight.isItem) {
      const boundBox = this.distanceRight.item.getBoundRect();
      this.itemBoundRectRight.resize({ width: Math.round(boundBox.width), height: Math.round(boundBox.height), x: boundBox.x, y: boundBox.y }, this.distanceRight.item.itemInfo);
      this.itemBoundRectRight.show();
    }
    if (this.distanceTop.isItem) {
      const boundBox = this.distanceTop.item.getBoundRect();
      this.itemBoundRectTop.resize({ width: Math.round(boundBox.width), height: Math.round(boundBox.height), x: boundBox.x, y: boundBox.y }, this.distanceTop.item.itemInfo);
      this.itemBoundRectTop.show();
    }
    if (this.distanceBottom.isItem) {
      const boundBox = this.distanceBottom.item.getBoundRect();
      this.itemBoundRectBottom.resize({ width: Math.round(boundBox.width), height: Math.round(boundBox.height), x: boundBox.x, y: boundBox.y }, this.distanceBottom.item.itemInfo);
      this.itemBoundRectBottom.show();
    }
    if (this.distanceLeft.isItem) {
      const boundBox = this.distanceLeft.item.getBoundRect();
      this.itemBoundRectLeft.resize({ width: Math.round(boundBox.width), height: Math.round(boundBox.height), x: boundBox.x, y: boundBox.y }, this.distanceLeft.item.itemInfo);
      this.itemBoundRectLeft.show();
    }
  }

  /**
   * 距離テキストボックスへの入力に関してアイテムを移動する
   * @param newDistance
   * @param direction
   * @param isMoveFinished 動かし終わりとして扱うか（数値の入力のとき。ドラッグ中の吸着は、マウスアップで扱う）
   */
  moveItemWithInput(newDistance: number, direction: string, isMoveFinished: boolean = false): void {
    if (!this.target.isCapableOfMove()) return;
    let distance = newDistance;
    this.target.saveCurrentPosition();
    if (distance != null) {
      if (distance < ALMOST_ZERO) distance = ALMOST_ZERO;
      const distInPix = marietta.webcad.util.WebCADUtil.convertMMToPix(distance);
      switch (direction) {
        case 'Top':
          if (!this.distanceTop) return;
          if (distInPix < this.distanceTop.distance) {
            this.target.itemInfo.y -= (this.distanceTop.distance - distInPix);
          } else {
            this.target.itemInfo.y += (distInPix - this.distanceTop.distance);
          }
          break;
        case 'Right':
          if (!this.distanceRight) return;
          if (distInPix < this.distanceRight.distance) {
            this.target.itemInfo.x += (this.distanceRight.distance - distInPix);
          } else {
            this.target.itemInfo.x -= (distInPix - this.distanceRight.distance);
          }
          break;
        case 'Bottom':
          if (!this.distanceBottom) return;
          if (distInPix < this.distanceBottom.distance) {
            this.target.itemInfo.y += (this.distanceBottom.distance - distInPix);
          } else {
            this.target.itemInfo.y -= (distInPix - this.distanceBottom.distance);
          }
          break;
        case 'Left':
          if (!this.distanceLeft) return;
          if (distInPix < this.distanceLeft.distance) {
            this.target.itemInfo.x -= (this.distanceLeft.distance - distInPix);
          } else {
            this.target.itemInfo.x += (distInPix - this.distanceLeft.distance);
          }
          break;
        default: break;
      }
      this.target.updateTransforms();
      this.syncMeToTarget();
      // 履歴に載せる前に呼ぶ
      if (isMoveFinished) {
        marietta.webcad.WebCADGlobal.itemManager.onItemsMoved();
      }
      // marietta.webcad.WebCADGlobal.itemManager.currentItem = this.target;
      if (this.target.previousPlace && marietta.core.Point.distance(this.target.previousPlace, new marietta.core.Point(this.target.itemInfo.x, this.target.itemInfo.y)) !== 0) {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
      }
    }
  }

  /**
   * 回転の開始（位置のリセット）
   * @param MouseEvent
   */
  rotateStartWithGuide = () => {
    this.x = this.target.itemInfo.x;
    this.y = this.target.itemInfo.y;
    this.updateTransforms();

    let { width } = this.target.spt;
    let { height } = this.target.spt;
    if (this.target instanceof marietta.webcad.item.Stair) {
      width = (this.target as marietta.webcad.item.Stair).patternSpt.width;
      height = (this.target as marietta.webcad.item.Stair).patternSpt.height;
    }

    // ピッカー
    this.dragObj_T.move(0, -height / 2);
    this.dragObj_TL.move(-width / 2, -height / 2);
    this.dragObj_TR.move(width / 2, -height / 2);
    this.dragObj_L.move(-width / 2, 0);
    this.dragObj_R.move(width / 2, 0);
    this.dragObj_B.move(0, height / 2);
    this.dragObj_BL.move(-width / 2, height / 2);
    this.dragObj_BR.move(width / 2, height / 2);
    this.rotator.move(-6.5, (-height / 2 - 25));

    this.allBox.move(this.dragObj_TL.x + (this.dragObj_TR.x - this.dragObj_TL.x) / 2, this.dragObj_TL.y + (this.dragObj_BL.y - this.dragObj_TL.y) / 2);
    this.itemguide.move(this.dragObj_TL.x + (this.dragObj_TR.x - this.dragObj_TL.x) / 2, this.dragObj_TL.y + (this.dragObj_BL.y - this.dragObj_TL.y) / 2);
  };

  /**
   * 回転する
   * @param MouseEvent
   */
  rotateWithGuide = (e: MouseEvent) => {
    // ロックされている場合は、行わない
    if (!this.target.isCapableOfRotate()) return;

    // this.syncMeToTarget();
    // this.resizeToTarget();
    // this.allBox.move( this.dragObj_TL.x + ( this.dragObj_TR.x  - this.dragObj_TL.x )/2 ,
    // this.dragObj_TL.y + ( this.dragObj_BL.y  - this.dragObj_TL.y )/2 );

    // const rect = this.target.viewObj.getBoundingClientRect();
    const firstPoint: marietta.core.Point = new marietta.core.Point(this.target.itemInfo.x, this.target.itemInfo.y);
    const newPoint: marietta.core.Point = marietta.webcad.util.WebCADUtil.convertToLocalPoint(e);
    const secondPoint: marietta.core.Point = new marietta.core.Point(newPoint.x, newPoint.y);

    // レイヤーのスケーリング分を考慮
    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    secondPoint.x -= Stage.offsetX - marietta.webcad.WebCADGlobal.OUTERFRAME_LEFT_FRAME_WIDTH;
    secondPoint.y -= Stage.offsetY - marietta.webcad.WebCADGlobal.OUTERFRAME_HEADER_HEIGHT;
    secondPoint.x /= root.scaleX;
    secondPoint.y /= root.scaleY;

    // 角度
    const radian: number = Math.atan2((firstPoint.x - secondPoint.x), (firstPoint.y - secondPoint.y));
    let angle: number = -radian / (Math.PI / 180) + 360;
    let unit: number = 45;
    if (this.target instanceof marietta.webcad.item.Stair) {
      unit = 90;
    }

    if (angle % unit > 5 && angle % unit < unit - 5) {
      this.rotator.showAssist(false);
    } else {
      this.rotator.showAssist(true);
      angle = Math.round(angle / unit) * unit;
    }

    this.rotation = angle;

    this.updateTransforms();

    // ターゲットを回転
    this.target.rotate(angle);

    const boundBox = this.target.getBoundRect();
    this.itemguide.resize({ width: boundBox.width, height: boundBox.height });

    if (this.emptySpt) {
      this.emptySpt.setEmptyParam(this.target.spt);
    }
  }

  /**
   * コントロールピッカーが移動された
   */
  moveControlPicker(e: MouseEvent, target: marietta.webcad.control.parts.ControlPicker) {
    // ロックされている場合は、行わない
    if (!this.target.isCapableOfResize()) return;
    // 開始時のアイテム場所保持
    if (this.startPoint === undefined) {
      // this.startPoint = new marietta.core.Point( this.target.itemInfo.x, this.target.itemInfo.y );
      if (this.emptySpt === undefined) {
        /*
          本来はtarget.sptのmouseX/mouseYで取得できるが、
          拡縮するとアイテムの位置が変わるため、正しいドラッグ位置が取れなくなる。
          そのためタグを持たないemptySptを別途作って、mouseX/mouseYの値を
          取得している。
        */
        this.emptySpt = new SVGSprite(null, true);
        this.emptySpt.setEmptyParam(this.target.spt);
        this.target.spt.parent.addChild(this.emptySpt);
      }
      this.startPoint = new marietta.core.Point(
        this.emptySpt.mouseX * this.target.spt.scaleX,
        this.emptySpt.mouseY * this.target.spt.scaleY,
      );
      // added k.kubonaka (WEBCAD-1020対応)
      this.resizeToTarget();
    }

    // var newPoint:marietta.core.Point = marietta.webcad.util.WebCADUtil.convertToLocalPoint(e);
    const newPoint: marietta.core.Point = new marietta.core.Point(
      this.emptySpt.mouseX * this.target.spt.scaleX,
      this.emptySpt.mouseY * this.target.spt.scaleY,
    );
    // アイテムの角度分、座標変換を行う
    const r: number = -((this.target.spt.rotation % 360) / 180) * Math.PI;
    const xx: number = newPoint.x * Math.cos(r) - newPoint.y * Math.sin(r);
    const yy: number = newPoint.x * Math.sin(r) + newPoint.y * Math.cos(r);
    newPoint.x = xx;
    newPoint.y = yy;

    // 他のピッカーの制限
    const minGap: number = this.getMinPickerGap();
    switch (target) {
      case this.dragObj_T:
        if (this.dragObj_B.y - minGap < newPoint.y) newPoint.y = this.dragObj_B.y - minGap;
        break;
      case this.dragObj_B:
        if (this.dragObj_T.y + minGap > newPoint.y) newPoint.y = this.dragObj_T.y + minGap;
        break;
      case this.dragObj_L:
        if (this.dragObj_R.x - minGap < newPoint.x) newPoint.x = this.dragObj_R.x - minGap;
        break;
      case this.dragObj_R:
        if (this.dragObj_L.x + minGap > newPoint.x) newPoint.x = this.dragObj_L.x + minGap;
        break;
      case this.dragObj_TL:
        if (this.dragObj_B.y - minGap < newPoint.y) newPoint.y = this.dragObj_B.y - minGap;
        if (this.dragObj_R.x - minGap < newPoint.x) newPoint.x = this.dragObj_R.x - minGap;
        break;
      case this.dragObj_TR:
        if (this.dragObj_B.y - minGap < newPoint.y) newPoint.y = this.dragObj_B.y - minGap;
        if (this.dragObj_L.x + minGap > newPoint.x) newPoint.x = this.dragObj_L.x + minGap;
        break;
      case this.dragObj_BL:
        if (this.dragObj_T.y + minGap > newPoint.y) newPoint.y = this.dragObj_T.y + minGap;
        if (this.dragObj_R.x - minGap < newPoint.x) newPoint.x = this.dragObj_R.x - minGap;
        break;
      case this.dragObj_BR:
        if (this.dragObj_T.y + minGap > newPoint.y) newPoint.y = this.dragObj_T.y + minGap;
        if (this.dragObj_L.x + minGap > newPoint.x) newPoint.x = this.dragObj_L.x + minGap;
        break;
      default: break;
    }

    // ドラッグ範囲
    // 他のピッカーの整理
    switch (target) {
      case this.dragObj_T:
      case this.dragObj_B:
        target.moveY(newPoint.y/* - this.target.itemInfo.y */);
        break;
      case this.dragObj_L:
      case this.dragObj_R:
        target.moveX(newPoint.x/* - this.target.itemInfo.x */);
        break;
      default:
        target.move(newPoint.x/* - this.target.itemInfo.x */, newPoint.y/* - this.target.itemInfo.y */);
        break;
    }

    // 他のピッカーの整理
    switch (target) {
      case this.dragObj_T:
        this.dragObj_TR.moveY(target.y);
        this.dragObj_TL.moveY(target.y);
        break;
      case this.dragObj_B:
        this.dragObj_BR.moveY(target.y);
        this.dragObj_BL.moveY(target.y);
        break;
      case this.dragObj_L:
        this.dragObj_TL.moveX(target.x);
        this.dragObj_BL.moveX(target.x);
        break;
      case this.dragObj_R:
        this.dragObj_TR.moveX(target.x);
        this.dragObj_BR.moveX(target.x);
        break;
      case this.dragObj_TL:
        this.dragObj_L.moveX(target.x);
        this.dragObj_BL.moveX(target.x);
        this.dragObj_TR.moveY(target.y);
        this.dragObj_T.moveY(target.y);
        break;
      case this.dragObj_TR:
        this.dragObj_R.moveX(target.x);
        this.dragObj_BR.moveX(target.x);
        this.dragObj_TL.moveY(target.y);
        this.dragObj_T.moveY(target.y);
        break;
      case this.dragObj_BL:
        this.dragObj_L.moveX(target.x);
        this.dragObj_TL.moveX(target.x);
        this.dragObj_BR.moveY(target.y);
        this.dragObj_B.moveY(target.y);
        break;
      case this.dragObj_BR:
        this.dragObj_R.moveX(target.x);
        this.dragObj_TR.moveX(target.x);
        this.dragObj_BL.moveY(target.y);
        this.dragObj_B.moveY(target.y);
        break;
      default: break;
    }
    this.rotator.move(this.dragObj_T.x - 6.5, this.dragObj_T.y - 25);
    // 中点の再配置
    switch (target) {
      case this.dragObj_T:
      case this.dragObj_B:
        this.dragObj_L.moveY(this.dragObj_B.y + (this.dragObj_T.y - this.dragObj_B.y) / 2);
        this.dragObj_R.moveY(this.dragObj_B.y + (this.dragObj_T.y - this.dragObj_B.y) / 2);
        break;
      case this.dragObj_L:
      case this.dragObj_R:
        this.dragObj_T.moveX(this.dragObj_L.x + (this.dragObj_R.x - this.dragObj_L.x) / 2);
        this.dragObj_B.moveX(this.dragObj_L.x + (this.dragObj_R.x - this.dragObj_L.x) / 2);
        break;
      default:
      case this.dragObj_TL:
      case this.dragObj_TR:
      case this.dragObj_BL:
      case this.dragObj_BR:
        this.dragObj_L.moveY(this.dragObj_B.y + (this.dragObj_T.y - this.dragObj_B.y) / 2);
        this.dragObj_R.moveY(this.dragObj_B.y + (this.dragObj_T.y - this.dragObj_B.y) / 2);
        this.dragObj_T.moveX(this.dragObj_L.x + (this.dragObj_R.x - this.dragObj_L.x) / 2);
        this.dragObj_B.moveX(this.dragObj_L.x + (this.dragObj_R.x - this.dragObj_L.x) / 2);
        break;
    }

    // 矩形のサイズ変更
    const rect = {
      x: this.dragObj_BL.x, y: this.dragObj_BL.y, width: (this.dragObj_BR.x - this.dragObj_BL.x), height: (this.dragObj_BR.y - this.dragObj_TR.y),
    };
    this.allBox.resize(rect);
    this.allBox.move(this.dragObj_TL.x + (this.dragObj_TR.x - this.dragObj_TL.x) / 2, this.dragObj_TL.y + (this.dragObj_BL.y - this.dragObj_TL.y) / 2);
    // this.itemguide.move(this.target.itemInfo.x, this.target.itemInfo.y);
    // ターゲットのリサイズ
    this.resizeTarget();
    // アイコンボタンの位置更新
    this.updateIconButtons();

    const boundBox = this.target.getBoundRect();
    this.itemguide.resize({ width: boundBox.width, height: boundBox.height });
    this.itemguide.move(0, 0);
    this.guideSpt.x = this.target.itemInfo.x;
    this.guideSpt.y = this.target.itemInfo.y;
    this.guideSpt.update();
    const dist = this.calculateDistance();
    if (dist && dist.top !== undefined && dist.right !== undefined && dist.bottom !== undefined && dist.left !== undefined) {
      this.showGuide(dist.top, dist.right, dist.bottom, dist.left);
    } else {
      this.hideItemGuide();
    }
  }

  /**
   * コントロールピッカーのドラッグ終了
  */
  onMoveEndControlPicker = () => {
    // 階段の場合は、サイズ更新
    if (this.target instanceof marietta.webcad.item.Stair) {
      // ターゲットのリサイズ
      this.resizeTarget();
      this.target.spt.visible = true;
      this.target.spt.update();
    }

    this.startPoint = undefined;

    if (this.emptySpt && this.emptySpt.parent) {
      this.emptySpt.parent.removeChild(this.emptySpt);
      this.emptySpt = undefined;
    }

    // アイコンボタンの位置更新
    this.updateIconButtons();

    // ライン測定を更新する
    const targetId = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.id;
    const targetKey = targetId.substring(0, 3);
    if (targetKey === ITEM_MODE_KEY.MODE_STAIR_KEY) {
      marietta.webcad.WebCADGlobal.updateMeasureLine();
      // StaircornerDragの最後に測定線を表示する
      marietta.webcad.WebCADGlobal.itemManager.showMeasureLine();
    }
    marietta.webcad.WebCADGlobal.quotationItemList.createData();
  }

  /**
   * ロック中はガイド寸法も編集不可にする。
   * 基底クラスのコンストラクタからも呼ばれるため、ガイド未生成の場合を考慮する。
   */
  public hideToolTips(): void {
    super.hideToolTips();
    this.itemguide?.disableInputs();
  }

  /**
   * ロック解除時にガイド寸法の編集を再度許可する。
   */
  public showToolTips(): void {
    super.showToolTips();
    this.itemguide?.enableInputs();
  }

  // アイテムガイドの表示
  showItemGuide() {
    const dist = this.calculateDistance();
    if (dist && dist.top !== undefined && dist.right !== undefined && dist.bottom !== undefined && dist.left !== undefined) {
      this.showGuide(dist.top, dist.right, dist.bottom, dist.left);
    } else {
      this.hideItemGuide();
    }
  }

  // アイテムガイドの非表示
  hideItemGuide() {
    this.itemguide.hide();
    if (document.getElementById('itemBoundGuide')) {
      document.getElementById('itemBoundGuide').remove();
    }
  }
}
